import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/SectionHeading";
import ProjectCard from "@/components/projects/ProjectCard";
import { listPublishedProjects } from "@/content/projects";
import { formHref } from "@/constants/formAnchors";
import { track } from "@/lib/analytics";

const COMING_SOON = {
  id: "additional-projects",
  slug: "additional-projects",
  format: null,
  status: "Coming Soon",
  title: "Future Projects",
  shortDescription:
    "Future SoKno Productions projects and announcements will be shared as development continues.",
  muted: true,
};

export default function Projects() {
  const published = listPublishedProjects();

  return (
    <section
      id="projects"
      className="section section-tone section-tone-projects"
      style={{ backgroundColor: "var(--section-projects)" }}
      data-testid="projects-section"
    >
      <div className="container-x">
        <SectionHeading
          eyebrow="Projects"
          title="Stories in Motion."
          testId="projects-heading"
          rightSlot={
            <Link
              to="/projects"
              data-testid="projects-index-link"
              className="link-gold"
              onClick={() =>
                track("cta_click", {
                  route: "/",
                  cta_label: "All projects",
                  source_category: "home_projects",
                })
              }
            >
              All projects <span aria-hidden>→</span>
            </Link>
          }
        >
          Films in development, production, and post.
        </SectionHeading>

        <div
          className="grid gap-6 mt-14"
          style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))" }}
          data-testid="projects-grid"
        >
          {published.map((p, i) => (
            <ProjectCard key={p.slug} project={p} index={i} />
          ))}
          <ProjectCard
            project={COMING_SOON}
            index={published.length}
            muted
            linkToDetail={false}
          />
        </div>

        <div className="mt-8">
          <Link
            to={formHref("project")}
            data-testid="projects-inquiry-link"
            className="link-gold"
            onClick={() =>
              track("cta_click", {
                route: "/",
                cta_label: "Project Inquiry",
                source_category: "home_projects",
              })
            }
          >
            Project Inquiry <span aria-hidden>→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
